import React, { useContext } from "react";
import { Navigate } from "react-router-dom";

import ModeSwitch from "../../lib/ModeSwitch";
import RedirectReceiptPageProvider from "./RedirectReceiptPageProvider";
import useSweepstakesQuery from "../../lib/useSweepstakesQuery";
import { sweepstakesQuery } from "./gql";
import { BootParameterContext } from "../../lib/BootParameterProvider";
import Receipt from "./Receipt";
import Redirect from "./Redirect";
import Failure from "./Failure";
import Page from "./Page";

const ReceiptPage = () => {
  const bootstrap = useContext(BootParameterContext);
  const { data, loading, error } = useSweepstakesQuery(sweepstakesQuery);

  if (!bootstrap.paymentIntentClientSecret) {
    return <Navigate to="/" />;
  }

  if (loading || error) {
    return null;
  }

  const { sweepstakes } = data;

  return (
    <RedirectReceiptPageProvider bootstrap={bootstrap} sweepstakes={sweepstakes}>
      <Page nonprofit={sweepstakes.nonprofit}>
        <ModeSwitch initialMode="redirect">
          <Redirect mode="redirect" />
          <Receipt mode="receipt" />
          <Failure mode="failure" />
        </ModeSwitch>
      </Page>
    </RedirectReceiptPageProvider>
  );
}

export default ReceiptPage;
